import { Col, Row } from "antd";
import TermsAndConditionsSection from "../components/Sections/TermsAndConditionsSection";
import { useUser } from "../context/UserContext";
import { hasRoleAccess } from "../utils/constants";

const TermsAndConditions = () => {
  const { roles } = useUser();

  if (!hasRoleAccess(roles, ["ADMIN", "HR"])) {
    return null;
  }

  return (
    <Row>
      <Col xs={24}>
        <TermsAndConditionsSection />
      </Col>
    </Row>
  );
};

export default TermsAndConditions;
